import { render } from "./detail-open-invoice.vue?vue&type=template&id=394d1020&ts=true"
import script from "./detail-open-invoice.vue?vue&type=script&lang=ts"
export * from "./detail-open-invoice.vue?vue&type=script&lang=ts"

import "./detail-open-invoice.vue?vue&type=style&index=0&id=394d1020&lang=scss"
import "./detail-open-invoice.vue?vue&type=style&index=1&id=394d1020&media=print&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__